import { Fragment, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Moment from "react-moment";
import { Col, Row } from "reactstrap";
import { useAppSelector } from "../../hooks/hooks";

interface Props {
    serial: string;
}

const DellSupppot = ({ serial }: Props) => {

    const dellWarranty = useAppSelector(d => d.dellWarranty.dellWarranty);

    const [sw, setSw] = useState<boolean>(false);

    return (
        <Row className="d-flex flex-column flex-sm-row justify-content-start me-5 pe-3">
            <Col className="mb-3 text-nowrap ms-sm-5 w-25">
                <span>{serial}</span>
            </Col>
            <Col sm={3}
                role="button"
                tabIndex={0}
                aria-expanded={sw}
                aria-label={sw ? `Collapse warranty for ${serial}` : `Expand warranty for ${serial}`}
                onClick={() => setSw(!sw)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setSw(!sw); } }}
                className="bcd-pointer"
            >
                See Warranty
                <FontAwesomeIcon icon={!sw ? 'angles-down' : 'angles-up'} size="lg" className='text-primary ms-2' />
            </Col>
            {
                sw && Array.isArray(dellWarranty) && dellWarranty.filter(f => f.serviceTag.toLowerCase().trim() === serial.toLowerCase().trim()).map((dell) => {
                    return (
                        <Fragment key={dell.id}>
                            <Row className="d-flex flex-column flex-sm-row justify-content-start me-5 pe-3 fade-in">
                                <Col className="mb-3 text-nowrap ms-sm-5 w-25">
                                    <label className="fw-bold">
                                        Service Tag
                                    </label>
                                    <p>
                                        {dell.serviceTag}
                                    </p>
                                </Col>
                                <Col className="mb-3">
                                    <label className="fw-bold">
                                        Product Line Description
                                    </label>
                                    <p>
                                        {dell.productLineDescription}
                                    </p>
                                </Col>
                            </Row>
                            {
                                dell.entitlements.map((e, ei) => {
                                    return (
                                        <Fragment key={`${dell.id}-entitlement-${ei}`}>
                                            <hr className="ms-5 text-warning"></hr>
                                            <Row className="d-flex justify-content-start me-5 pe-3 fade-in">
                                                <Col className="ms-5 w-25">
                                                    <label className="fw-bold">
                                                        Service Level Description
                                                    </label>
                                                    <p>
                                                        {e.serviceLevelDescription}
                                                    </p>
                                                </Col>
                                            </Row>
                                            <Row className="d-flex justify-content-start me-5 pe-3">
                                                <Col className="mb-3 text-nowrap ms-5 w-25">
                                                    <label className="fw-bold">
                                                        Start Date
                                                    </label>
                                                    <div>
                                                        <Moment format="MM/DD/YYYY" className="text-info">
                                                            {e.startDate}
                                                        </Moment>
                                                    </div>
                                                </Col>
                                                <Col className="mb-3">
                                                    <label className="fw-bold">
                                                        End Date
                                                    </label>
                                                    <div>
                                                        <Moment format="MM/DD/YYYY" className="text-danger">
                                                            {e.endDate}
                                                        </Moment>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Fragment>
                                    )
                                })
                            }
                            <hr className="ms-5 text-primary"></hr>
                        </Fragment>
                    )
                })
            }
            <hr className="ms-5 text-info"></hr>
        </Row>
    );
}

export default DellSupppot;
